import React, { useState, useEffect } from 'react';

import { useManagedContext } from "../../components/hooks"
import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { useLista } from '../../components/hooks/useLista';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading } from '../../components/common';
import PlantillaDocumentoModal from '../../components/controls/PlantillaDocumentoModal';
import { standardRequest } from '../../utils/requests';

function PlantillasDocumentosView() {
    const { setIsLoading, showMessageModal } = useManagedContext()

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        list: []
    });

    const mount = () => {

        SearchPlantillasDocumentos();
        
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [, getRowLista ] = useLista({
        listas: ['TipoPlantillaDocumento'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'TipoPlantillaDocumento',
          timeout: 0
        }
    });

    const getDescTipoPlantillaDocumento = (id) => {
        const row = getRowLista('TipoPlantillaDocumento', id);
        return (row) ? row.nombre : '';
    }

    //definiciones
    const tableColumns = [
        { Header: 'Tipo plantilla', Cell: (props) => { return getDescTipoPlantillaDocumento(props.value); }, accessor: 'idTipoPlantillaDocumento', width: '40%' },
        { Header: 'Descripción', accessor: 'descripcion', width: '50%' },
    ];

    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const plantilla = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar la plantilla ${plantilla.descripcion}?`,
                onConfirm: () => {
                    setIsLoading(true)

                    standardRequest(REQUEST_METHOD.DELETE, `${APIS.URLS.PLANTILLA_DOCUMENTO}/${id}`)
                    .then(() => SearchPlantillasDocumentos())
                    .catch(() => {})
                    .finally(() => setIsLoading(false))
                }
            })
        },
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchPlantillasDocumentos() {
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [] }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaCreacion) x.fechaCreacion = new Date(x.fechaCreacion);
                });
                setIsLoading(false)
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };


        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            null,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
    <>
        {state.showForm && 
            <PlantillaDocumentoModal
                id={state.rowId}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });
                    SearchPlantillasDocumentos();
                }}
            />
        }

        <SectionHeading titles={['Legales', 'Plantillas documentos']} />

        <section className='section-accordion'>

            <div className="m-top-20">

                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={state.list}
                    avmr={avmr}
                    editCode="apremio_edit"
                />

            </div>

        </section>
        
    </>
    )
}

export default PlantillasDocumentosView;
